"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUserMakeAppointment = exports.closeModal = exports.openModal = exports.setRebookingMode = exports.clearCurrentBooking = exports.setBookedAppointments = exports.setCurrentBooking = exports.updateCurrentBooking = exports.setCurrentCalendarYear = exports.setCurrentCalendarMonth = exports.setSelectedTime = exports.setSelectedDate = exports.setStepIndex = exports.bookingSlice = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const dayjs_1 = __importDefault(require("dayjs"));
const lodash_1 = require("lodash");
const today = (0, dayjs_1.default)();
exports.initialState = {
    currentStepIndex: 0,
    currentBooking: {
        locationId: undefined,
        date: {
            selectedDate: undefined,
            currentCalendarYear: today.get('year'),
            currentCalendarMonth: today.get('month'),
            selectedTime: undefined,
        },
        calendarId: undefined,
        slotId: undefined,
        slotFromDate: undefined,
        slotToDate: undefined,
        donationType: undefined,
    },
    bookedAppointments: [],
    isModalOpen: false,
    isRebooking: false,
};
exports.bookingSlice = (0, toolkit_1.createSlice)({
    name: 'booking',
    initialState: exports.initialState,
    reducers: {
        setStepIndex: (state, action) => {
            state.currentStepIndex = action.payload;
        },
        setSelectedDate: (state, action) => {
            state.currentBooking.date.selectedDate = action.payload;
            state.currentBooking.date.selectedTime = undefined;
        },
        setSelectedTime: (state, action) => {
            state.currentBooking.date.selectedTime = action.payload;
        },
        setCurrentCalendarYear: (state, action) => {
            state.currentBooking.date.currentCalendarYear = action.payload;
        },
        setCurrentCalendarMonth: (state, action) => {
            state.currentBooking.date.currentCalendarMonth = action.payload;
        },
        updateCurrentBooking: (state, action) => {
            (0, lodash_1.set)(state.currentBooking, action.payload.prop, action.payload.value);
        },
        setCurrentBooking: (state, action) => {
            state.currentBooking = action.payload;
        },
        setBookedAppointments: (state, action) => {
            state.bookedAppointments = action.payload;
        },
        clearCurrentBooking: (state) => {
            state.currentBooking = {
                locationId: undefined,
                date: {
                    selectedDate: undefined,
                    currentCalendarYear: today.get('year'),
                    currentCalendarMonth: today.get('month'),
                    selectedTime: undefined,
                },
                calendarId: undefined,
                slotId: undefined,
                donationType: undefined,
                slotFromDate: undefined,
                slotToDate: undefined,
            };
            state.currentStepIndex = 0;
        },
        setRebookingMode: (state, action) => {
            state.isRebooking = action.payload.isRebooking;
            state.currentBooking.appointmentId = action.payload.appointmentId;
        },
        openModal: (state) => {
            state.isModalOpen = true;
        },
        closeModal: (state) => {
            state.isModalOpen = false;
        },
    },
});
_a = exports.bookingSlice.actions
// Selectors
, exports.setStepIndex = _a.setStepIndex, exports.setSelectedDate = _a.setSelectedDate, exports.setSelectedTime = _a.setSelectedTime, exports.setCurrentCalendarMonth = _a.setCurrentCalendarMonth, exports.setCurrentCalendarYear = _a.setCurrentCalendarYear, exports.updateCurrentBooking = _a.updateCurrentBooking, exports.setCurrentBooking = _a.setCurrentBooking, exports.setBookedAppointments = _a.setBookedAppointments, exports.clearCurrentBooking = _a.clearCurrentBooking, exports.setRebookingMode = _a.setRebookingMode, exports.openModal = _a.openModal, exports.closeModal = _a.closeModal;
exports.canUserMakeAppointment = (0, toolkit_1.createSelector)([
    (state) => { var _a; return (_a = state.app.appSettings) === null || _a === void 0 ? void 0 : _a.nextDonationWait; },
    (state) => { var _a; return (_a = state.app.appSettings) === null || _a === void 0 ? void 0 : _a.maxAllowedComingAppointments; },
    (state) => state.booking.bookedAppointments,
    (state) => { var _a; return (_a = state.app.user) === null || _a === void 0 ? void 0 : _a.donorDonationTypeDatas; },
    (state) => { var _a; return (_a = state.app.user) === null || _a === void 0 ? void 0 : _a.lastDonationDate; },
], (nextDonationWait, maxAllowedComingAppointments, bookedAppointments, donorDonationTypeDatas, lastDonationDate) => {
    const userDonationTypes = (0, lodash_1.map)(donorDonationTypeDatas, (d) => d.donationTypeEnum);
    const donationTypeAllowed = (0, lodash_1.map)(userDonationTypes, (donationType) => {
        var _a;
        const filteredAppointments = (0, lodash_1.filter)(bookedAppointments, {
            donationTypeEnum: donationType,
        });
        const bookedDonationDate = (0, lodash_1.get)(_(filteredAppointments).sortBy(['fromDate']).first(), 'fromDate');
        const furthestBookedDonationDate = (0, lodash_1.get)(_(filteredAppointments).sortBy(['fromDate']).last(), 'fromDate');
        const waitingTime = (0, lodash_1.get)((0, lodash_1.find)(nextDonationWait, { donationTypeEnum: donationType }), 'daysToWait');
        const hasMaxNumAppointments = (0, lodash_1.size)(filteredAppointments) >= ((_a = maxAllowedComingAppointments === null || maxAllowedComingAppointments === void 0 ? void 0 : maxAllowedComingAppointments[donationType]) !== null && _a !== void 0 ? _a : 0);
        const needToWait = waitingTime === undefined ||
            (0, dayjs_1.default)().diff((0, dayjs_1.default)(bookedDonationDate || lastDonationDate), 'days') <= waitingTime;
        const daysToBookable = Math.max(0, (0, dayjs_1.default)(furthestBookedDonationDate || lastDonationDate).diff((0, dayjs_1.default)(), 'days') +
            (waitingTime !== null && waitingTime !== void 0 ? waitingTime : 0));
        return {
            daysToBookable,
            donationType,
            canBook: !hasMaxNumAppointments || (hasMaxNumAppointments && !needToWait),
            reason: (0, lodash_1.compact)([
                hasMaxNumAppointments && 'hasMaxNumAppointments',
                needToWait && 'needToWait',
            ]),
        };
    });
    return Object.assign({ allowed: (0, lodash_1.some)(donationTypeAllowed, { canBook: true }) }, donationTypeAllowed);
});
exports.default = exports.bookingSlice.reducer;
